<template>
  <div>
    <div style="width: 100%; height: 250px" v-bind:id="id"></div>
  </div>
</template>

<script>
import { getUUID } from '../../../../../utils/util'
import chartResize from '@/mixin/chart-resize'
let unwatch
export default {
  mixins: [chartResize],
  name: 'NestedRing',
  components: {},
  data() {
    return {
      id: getUUID(),
    }
  },
  props: {
    data: {
      type: Object,
    },
    total: {
      type: Number,
    },
  },
  myChart: null,
  methods: {
    set(data) {
      var option
      option = {
        tooltip: {
          trigger: 'axis',
          // axisPointer: {
          //   type: 'cross',
          //   crossStyle: {
          //     color: '#999',
          //   },
          //   textStyle: {
          //     color: '#000000',
          //   },
          // },

          formatter: function (params) {
            // console.log('777',params);
            const dataIndex = params[0].dataIndex
            const nameS = params[0].seriesName.split(',')
            const nameText = nameS[dataIndex]
            // console.log(params[0].seriesName, nameS,dataIndex);
            var result = ''
            result +=
              '<span style="display:inline-block;margin-right:4px;border-radius:10px;width:10px;height:10px;background-color:#FB7800;"></span>' +
              params[0].name +
              '<br>' +
              '总数：' +
              nameText +
              '<br>' +
              '抄见率：' +
              params[0].data+'%'

            return result
          },
        },
        grid: data.grid,
        color: data.color,
        title: data.title,
        xAxis: {
          type: 'category',
          data: data.xdata,
          axisLabel: {
            rotate: data.rotate == 0 ? 0 : 30,
            margin: 8,
            formatter: function (params) {
              var val = ''
              if (params.length > 3) {
                val = params.substr(0, 3) + '..'
                return val
              } else {
                return params
              }
            },
          },
        },
        yAxis: {
          type: 'value',
          name:'%',
          axisLabel: {
            formatter: '{value}',
          },
        },
        series: [
          {
            data: data.sdata,
            name: data.vdata,
            type: 'bar',
            barWidth: data.barwidth ? data.barwidth : 18, //柱图宽度
          },
        ],
      }

      this.myChart.setOption(option)
      // window.addEventListener('resize', function() {
      //   this.myChart.resize()
      // })
    },
    drawRingGraph(id) {
      let _this = this
      this.myChart = echarts.init(document.getElementById(id))

      unwatch = this.$watch(
        'data',
        function (newvalue, oldvalue) {
          if (newvalue) {
            console.log(newvalue, 'newvalue')
            this.set(newvalue)
          }
        },
        { deep: true, immediate: true }
      )
    },
  },
  mounted() {
    this.drawRingGraph(this.id)
  },
  created() {},
  beforeDestroy() {
    if (unwatch) {
      unwatch()
      unwatch = null
    }
    if (!this.myChart) {
      this.myChart.dispose()
      this.myChart = null
    }
  },
}
</script>
<style lang="less" scoped>
</style>
